import { z } from "zod";
const CountSchema = z.number().int().nonnegative();
const TaskCountsSchema = z.strictObject({
    business: CountSchema,
    mandatory: CountSchema,
    total: CountSchema,
});
export const LocationDashboardSchema = z.strictObject({
    attention: z.strictObject({
        critical: CountSchema,
        major: CountSchema,
        minor: CountSchema,
        total: CountSchema,
    }),
    comingUp: CountSchema,
    dueToday: TaskCountsSchema,
    evidence: z.strictObject({
        completed: CountSchema,
        expected: CountSchema,
        percentage: z.number().min(0).max(100),
    }),
    excludedStaff: CountSchema,
    outOfRange: z.strictObject({
        fail: CountSchema,
        total: CountSchema,
        warn: CountSchema,
    }),
    overdue: TaskCountsSchema,
    training: z.strictObject({ current: CountSchema, total: CountSchema }),
    unavailable: z.array(z.string()),
    unsyncedDevices: CountSchema,
});
export const OrganisationOverviewSchema = z.strictObject({
    locations: z.array(z.strictObject({
        id: z.uuid(),
        name: z.string(),
        status: z.string(),
        timezone: z.string(),
        metrics: LocationDashboardSchema,
    })),
});
